import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NotificationService, NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

import { messages } from './messages';

export const showGenericErrorNotification = () => {
  NotificationService.showNotification({
    title: <FormattedMessage {...messages.paymentDetailsErrorTitle} />,
    content: <FormattedMessage {...messages.paymentDetailsErrorMessage} />,
    notificationType: NOTIFICATION_TYPE_ERROR,
  });
};

export const showGenericSuccessNotification = () => {
  NotificationService.showNotification({
    title: <FormattedMessage {...messages.paymentDetailsSuccessTitle} />,
    content: <FormattedMessage {...messages.paymentDetailsSuccessMessage} />,
    notificationType: NOTIFICATION_TYPE_SUCCESS,
  });
};
